<div class="layout-footer">
    <img src="assets/layout/images/{{layoutService.config.colorScheme === 'light' ? 'logo-developsoft' : 'logo-developsoft'}}.svg" alt="Logo" height="20" class="mr-2"/>
    by
    <span class="font-medium ml-2">DevelopSoft</span>
    <span class="font-medium ml-2">- ver.1.1.1</span>
</div>
